import {useRef,useMemo,useCallback} from "react";
import COMPONENT_MAP from '../Repository/Components.js';
import DataManagementDetailListOfValuesPopup from './DataManagementDetailListOfValuesPopup.js';
import {useSnackbar} from '../SnackbarContext.js';
import {useLoading} from '../LoadingContext';
import {refreshServerVariable} from '../../../core/integration/Api.js';

const DataManagementDetailListOfValues=({userData,application})=>{
    const list_name='list_of_values';
    const executeQuery=useRef(true);
    const {showSnackbar}=useSnackbar();
    const {showLoading,hideLoading}=useLoading();

    const refreshServerVariableCall=useCallback((api)=>{
        showLoading();
        refreshServerVariable(api).then((data)=>{
            if('error' in data){
                showSnackbar(data.error,'error');
            } 
            else{
                showSnackbar(data.message,'success');
            }
            hideLoading();
        });
    },[showLoading,hideLoading,showSnackbar]);

    const pageCallback=useCallback(async(action,args)=>{
        if(action==='invoke_method'){
            if(args.args.method_name==='refresh-list-of-values'){
                refreshServerVariableCall(args.args.method_name);
            }
        }
    },[refreshServerVariableCall]);

    const renderListTab=useMemo(()=>{
        const Component=COMPONENT_MAP['ListTab'];
        return Component?(
            <Component
                parentId={'null'}
                parentContext={{}}
                application={application}
                userData={userData}
                entityType={'ListOfValues'}
                entityParams={['_lang='+application.globalData.lang]}
                list_name={list_name}
                height={window.innerHeight-170}
                file={'DataManagementDetailListOfValues.js'}
                initialState={{}}
                navigateOnNew={null}
                filterComponent={null}
                checkboxSelection={true}
                disableRowSelectionOnClick={true}
                disableSelectionOnClick={true}
                popupComponent={DataManagementDetailListOfValuesPopup}
                focusOnSearchInput={true}
                pageCallback={pageCallback}
                executeQuery={executeQuery}
                button_actions={[
                    {name:'invoke_method',label:'ButtonClearCacheListOfValues',args:{method_name:'refresh-list-of-values'}},
                ]}
            />
        ):null; 
    },[application,userData,pageCallback]);

    return(renderListTab);
}

export default DataManagementDetailListOfValues;
